import React from 'react'
import { useTranslation } from 'react-i18next'
import ErrorMessage from 'components/share/ErrorMessage'
import { WidgetGuard } from 'features/types'
import ReturnStatus from 'enums/ReturnStatus'

import useSideBySideData from '../hooks/useSideBySideData'

const SideBySideLanguageNotSupportGuard: WidgetGuard = ({ widgetId, children }) => {
  const { isAllEmpty, allStatus } = useSideBySideData(widgetId)
  const { t } = useTranslation()

  const lanNotSupport = allStatus.every((status) => status === ReturnStatus.LANGUAGE_NOT_SUPPORTED)

  return isAllEmpty && lanNotSupport ? (
    <ErrorMessage>{t('topicLanguageUnsupported')}</ErrorMessage>
  ) : (
    children
  )
}

export default SideBySideLanguageNotSupportGuard
